import { HTTPResponse } from '@/services/http/http.types.ts'
import http, { handleHttpError, handleHttpResponse } from '../../../services/http'
import { IAlarmSituation, TCreateAlarmSituationDTO } from './alarmSituations.types.ts'

const createAlarmSituation = (dto: TCreateAlarmSituationDTO): Promise<HTTPResponse<IAlarmSituation>> => {
  return http.post('nsi/v1/alarm-situations/', dto).then(handleHttpResponse).catch(handleHttpError)
}

const updateAlarmSituation = (dto: IAlarmSituation): Promise<HTTPResponse<IAlarmSituation>> => {
  return http.patch(`/nsi/v1/alarm-situations/${dto.id}`, dto).then(handleHttpResponse).catch(handleHttpError)
}

const deleteAlarmSituation = (id: IAlarmSituation['id']): Promise<HTTPResponse<IAlarmSituation>> => {
  return http.delete(`/nsi/v1/alarm-situations/${id}`).then(handleHttpResponse).catch(handleHttpError)
}

const alarmSituationApi = {
  createAlarmSituation,
  updateAlarmSituation,
  deleteAlarmSituation,
}
export default alarmSituationApi
